// Stack-table engagement — modal kind. Aim-driven: hovering any sleeve in
// a stack engages browse mode on that stack. The wall-comic kind (lower
// precedence) picks up `stage.activeStackTable` and substitutes the
// current top sleeve as its hover target — that's where outline + E
// inspection happen. This kind's only job is to claim modal scope + set
// `stage.activeStackTable`.

import { registerInteractable } from "../_interactable-registry.js";

registerInteractable({
	id: "stack-table",
	precedence: 95,
	// ASK-137 §84 — THIS KIND'S OWN PROMPT AND SUBJECT. `stage.js` used to enumerate every kind by
	// hand, twice (`_updateEHint`'s hover ladder and `_hoveredProduct`), which is exactly what the
	// registry's own header says a registry exists to end. The prompt a shopper reads and the product
	// it names belong where the rest of this kind's behaviour already is.
	hoverHint: '<kbd>E</kbd> Inspect &nbsp;·&nbsp; <kbd>←→</kbd> Cycle',
	productOf(stage, active) {
		const s = stage.activeStackTable || active?.stack; if (!s?.sleeves?.length) return null;
		const N = s.sleeves.length; const top = (N - 1 - s.cycleCount + N * N) % N; return s.sleeves[top]?.product ?? null;
	},

	suppressedBy(stage) {
		// Box modal / hero claims always win.
		if (stage.boxState === "open" || stage.boxState === "browsing" || stage.boxState === "hero") return true;
		if (stage.activeFixtureHero) return true;
		if (!stage.stackTables?.length) return true;
		return false;
	},

	getTargets(stage) {
		const meshes = [];
		for (const stack of stage.stackTables) {
			for (const sleeve of stack.sleeves) meshes.push(sleeve.mesh);
		}
		return meshes;
	},

	onHit(stage, mesh) {
		const fi = mesh.userData?.interactable?.fixtureIndex;
		if (fi == null) return null;
		const stack = stage.stackTables.find((t) => t.fixtureIndex === fi) ?? null;
		return stack ? { stack } : null;
	},

	commitHover(stage, prev, next) {
		stage.activeStackTable = next?.stack ?? null;
	},

	// No interactE — the wall-comic kind handles E for the substituted top
	// sleeve (legacy behaviour: hoveredWallComic gets the top sleeve mesh,
	// E inspects it via inspectWallComic).
});
